import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'friendlyBoolean',
    pure: false // to force output re-evaluation
    ,
    standalone: false
})
export class FriendlyBooleanPipe implements PipeTransform {

  public values: any[] = [];
  public trueFriendlyValue;
  public falseFriendlyValue;

  constructor(public translateService: TranslateService) {
    this.trueFriendlyValue = this.translateService.instant('BOOLEANS.YES');
    this.falseFriendlyValue = this.translateService.instant('BOOLEANS.NO');

    this.values.push({id: 'true', name:this.trueFriendlyValue, text:this.trueFriendlyValue});
    this.values.push({id: 'false', name:this.falseFriendlyValue, text:this.falseFriendlyValue});
  }

  transform(value: any): string {
    this.trueFriendlyValue = this.translateService.instant('BOOLEANS.YES');
    this.falseFriendlyValue = this.translateService.instant('BOOLEANS.NO');

    if (typeof value === 'boolean') {
      return value ? this.trueFriendlyValue : this.falseFriendlyValue;
    }

    if (typeof value === 'number') {
      return value === 1 ? this.trueFriendlyValue : this.falseFriendlyValue;
    }

    if (typeof value === 'string') {
      const lowerCaseValue = value.toLowerCase();

      if (lowerCaseValue === 'true' || lowerCaseValue === '1') {
        return this.trueFriendlyValue;
      }

      if (lowerCaseValue === 'false' || lowerCaseValue === '0') {
        return this.falseFriendlyValue;
      }
    }

    // fallback for unexpected values
    return '-';
  }
}
